<template>
  <div class="upload-desc-wrap">
    <el-upload ref="upload"
               :action="''"
               :accept="accept"
               multiple
               :file-list="myList"
               :limit="limit"
               :show-file-list="false"
               :http-request="uploadSectionFile"
               :on-exceed="handleDescExceed">
      <el-button size="small"
                 type="primary">点击上传</el-button>
      <div slot="tip"
           class="el-upload__tip">
        上传图片不能超过{{ limit }}张，大小不超过 2MB！已上传 <span style="color:#409EFF">{{ myList.length }}</span> 张
      </div>
    </el-upload>
    <draggable v-model="myList"
               class="el-upload-list el-upload-list--text"
               element="ul"
               :options="dragOptions">
      <li v-for="(item, index) in myList"
          :key="item.url"
          class="el-upload-list__item is-success"
          style="cursor: move;">
        <a class="el-upload-list__item-name">
          <i class="el-icon-rank"></i>
          <i class="el-icon-document"></i>{{ item.url | getFilename() }}
        </a>
        <label class="el-upload-list__item-status-label">
          <i class="el-icon-upload-success el-icon-circle-check"></i>
        </label>
        <i class="el-icon-close"
           @click="deleteDesc(item, index)"></i>
      </li>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
export default {
  name: 'DescImages',
  components: { draggable },
  props: {
    accept: { type: String, default: 'image/*' },
    limit: { type: Number, default: 20 },
    value: { type: Array, default () { return [] } }
  },
  data () {
    return {
      dragOptions: { animation: 0, disabled: false, group: 'description', ghostClass: 'ghost' }
    }
  },
  computed: {
    myList: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    uploadSectionFile ({ file }) {
      const isLt = file.size / 1024 / 1024
      if (file.type.indexOf('image') > -1 && isLt > 2) {
        this.$message.error('上传图片文件大小不能超过 2MB!')
        return
      }
      this.uploadFile(file)
    },
    uploadFile (file) {
      const form = new FormData()
      form.append('file', file)
      form.append('attachImageSize', true)
      this.$store.dispatch('common/uploadfile', {
        payload: form,
        success: res => {
          this.myList.push({ url: res.data.viewUrl + res.data.filepath, name: file.name })
        },
        fail: () => {}
      })
    },
    handleDescExceed (files, fileList) {
      this.$message.warning(`当前限制选择 ${this.limit} 个图片，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    deleteDesc (item, index) {
      this.myList.splice(index, 1)
    }
  }
}
</script>
<style lang="stylus" scoped>
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.upload-desc-wrap {
  .el-upload-list__item-name, .el-upload-list__item-name * {
    cursor: grab !important;
  }
}
</style>
